<template>
    <el-dialog :title="syncChangeTitle" :visible.sync="directorChangeSyncVisible" width="600px" :before-close="handleDialogClose" :close-on-click-modal="false"
        :append-to-body="true" custom-class="custom-form-dialog director-change-sync-dialog">
        <div v-loading="formLoading">
            <p class="dialog-txt-tip" v-if="syncChangeType == 1">只可同步变更负责人为同一人的商机及订单，若变更后，新负责人可以操作商机及订单，原负责人可能没有权限操作</p>
            <p class="dialog-txt-tip" v-else>增加的成员对商机及订单拥有与客户相同的只读或读写权限</p>
            <div class="director-change-sync-content">
                <div class="flex-item flex-item-projects">
                    <div class="flex-item-title">
                        <el-checkbox :indeterminate="projectSelectsLen > 0 && projectSelectsLen < projects.length" v-model="projectsAllChecked"
                            @change="handleProjectAllChange"></el-checkbox><span>选择商机（{{ projectSelectsLen }}）</span>
                    </div>
                    <ul class="flex-item-content">
                        <li v-for="item in projects" :key="item.id" @click.stop="handleProjectsCheckChange(item)">
                            <el-checkbox v-model="item.checked" @change="handleProjectsCheckChange(item)"></el-checkbox>
                            <span>{{ item.project_name }}</span>
                        </li>
                    </ul>
                </div>
                <div class="flex-item flex-item-orders">
                    <div class="flex-item-title">
                        <el-checkbox :indeterminate="ordersSelectsLen > 0 && ordersSelectsLen < orders.length" v-model="ordersAllChecked"
                            @change="handleOrdersAllChange"></el-checkbox><span>选择订单（{{ ordersSelectsLen }}）</span>
                    </div>
                    <ul class="flex-item-content">
                        <li v-for="item in orders" :key="item.id" @click.stop="handleOrdersCheckChange(item)">
                            <div class="list-item-top">
                                <div>
                                    <el-checkbox v-model="item.checked" @change="handleOrdersCheckChange(item)"></el-checkbox>
                                    <span>XS-24020381938</span>
                                </div>

                                <span>2024-12-12</span>
                            </div>
                            <div class="list-item-bottom">
                                <div class="order-item-avatar">
                                    <img src="" alt="">
                                    <span>王五</span>
                                </div>
                                <span>¥2,000.00</span>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <span slot="footer" class="dialog-footer">
            <el-button @click.stop="handleDialogClose" :disabled="btnDisabled">取消</el-button>
            <el-button type="primary" @click.stop="handleDialogConfirm" :disabled="btnDisabled">变更</el-button>
        </span>
    </el-dialog>
</template>
<script>
export default {
    name: "DirectorChangeSync",
    props: {
        syncChangeTitle: {
            type: String,
            default: ""
        },
        directorChangeSyncVisible: {
            type: Boolean,
            default: false
        },
        syncChangeType: {
            type: Number,
            default: 1, // 1-同步变更负责人，2-同步增加团队成员
        }
    },
    data() {
        return {
            dialogVisible: false,
            formLoading: false,
            projectsAllChecked: true,
            ordersAllChecked: true,
            projects: [
                { id: 1, project_name: "商机1" },
                { id: 2, project_name: "商机2" },
                { id: 3, project_name: "商机3" },
                { id: 4, project_name: "商机4" },
                { id: 5, project_name: "商机5" },
                { id: 6, project_name: "商机1" },
                { id: 7, project_name: "商机1" },
                { id: 8, project_name: "商机1" },
            ],
            orders: [
                { id: 1, order_name: "订单1" },
                { id: 2, order_name: "订单2" },
                { id: 3, order_name: "订单3" },
                { id: 4, order_name: "订单4" },
                { id: 5, order_name: "订单5" },
                { id: 6, order_name: "订单1" },
                { id: 7, order_name: "订单1" },
                { id: 8, order_name: "订单1" },
            ],
            btnDisabled: false
        }
    },
    computed: {
        projectSelectsLen() {
            return this.projects.filter(item => item.checked).length
        },
        ordersSelectsLen() {
            return this.orders.filter(item => item.checked).length
        }
    },
    mounted() {
        this.projectsAllChecked = true
        this.projects.forEach(item => {
            this.$set(item, 'checked', true)
        })
        this.ordersAllChecked = true
        this.orders.forEach(item => {
            this.$set(item, 'checked', true)
        })
    },
    methods: {
        handleProjectsCheckChange(item) {
            this.$set(item, 'checked', !item.checked)
            this.projectsAllChecked = this.projects.every(item => item.checked)
        },
        handleOrdersCheckChange(item) {
            this.$set(item, 'checked', !item.checked)
            this.ordersAllChecked = this.orders.every(item => item.checked)
        },
        handleProjectAllChange(checked) {
            this.projects.forEach(item => {
                this.$set(item, "checked", checked)
            })
        },
        handleOrdersAllChange(checked) {
            this.orders.forEach(item => {
                this.$set(item, "checked", checked)
            })
        },
        handleDialogClose() {
            this.$emit("update:directorChangeSyncVisible", false)
        },
        handleDialogConfirm() {
            this.$refs.formData.validate(valid => {
                if (valid) {
                    console.log("校验成功")
                }
            })
        },
        getUserList(name) {

        }
    }
}
</script>
<style lang="scss">
.director-change-sync-dialog {
    .director-change-sync-content {
        height: 410px;
    }

    .director-change-sync-content {
        display: flex;
        gap: 16px;

        .flex-item {
            width: 100%;
            height: 100%;
            border-radius: 6px;
            border: 1px solid rgba(243, 243, 243, 1);

            .flex-item-title {
                padding: 0 12px;
                height: 38px;
                line-height: 38px;
                border-radius: 6px 6px, 0px, 0px;
                background: rgba(237, 240, 244, 1);

                &>span {
                    font-size: 14px;
                    font-weight: 700;
                    letter-spacing: 0px;
                    line-height: 22px;
                    color: rgba(51, 51, 51, 1);
                    margin-left: 8px;
                }
            }

            .flex-item-content {
                max-height: 370px;
                overflow-y: scroll;
            }

        }

        .flex-item-projects {
            .flex-item-content {
                padding: 8px 8px 0 4px;

                li {
                    margin-bottom: 4px;
                    padding: 4px 8px;
                    display: flex;
                    align-items: center;
                    gap: 8px;
                    font-size: 14px;
                    font-weight: 400;
                    letter-spacing: 0px;
                    line-height: 22px;
                    color: rgba(102, 102, 102, 1);
                    cursor: pointer;

                    &:hover {
                        border-radius: 4px;
                        background: rgba(0, 0, 0, 0.04);
                    }
                }
            }
        }

        .flex-item-orders {
            .flex-item-content {
                padding: 0 8px 0 4px;

                li {
                    padding: 12px 8px;
                    position: relative;
                    cursor: pointer;

                    &:hover {
                        border-radius: 4px;
                        background: rgba(0, 0, 0, 0.04);
                    }

                    &:not(:last-child) {
                        margin-top: 1px;

                        &::after {
                            content: "";
                            position: absolute;
                            bottom: -1px;
                            left: 8px;
                            right: 8px;
                            height: 1px;
                            background-color: rgba(232, 232, 232, 1);
                        }


                    }

                    .list-item-top {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;

                        &>div {
                            font-size: 14px;
                            font-weight: 400;
                            letter-spacing: 0px;
                            line-height: 22px;
                            color: rgba(51, 51, 51, 1);

                            &>span {
                                margin-left: 8px;
                            }
                        }

                        &>span {
                            font-size: 12px;
                            font-weight: 400;
                            letter-spacing: 0px;
                            line-height: 18px;
                            color: rgba(102, 102, 102, 1);
                        }

                    }

                    .list-item-bottom {
                        margin-top: 8px;
                        height: 22px;
                        display: flex;
                        justify-content: space-between;
                        align-items: center;

                        .order-item-avatar {
                            display: flex;
                            align-items: center;

                            img {
                                width: 22px;
                                height: 22px;
                                border-radius: 50%;
                                margin-right: 8px;
                            }


                            span {
                                font-size: 14px;
                                font-weight: 400;
                                letter-spacing: 0px;
                                line-height: 22px;
                                color: rgba(51, 51, 51, 1);
                            }
                        }

                        &>span {
                            font-size: 14px;
                            font-weight: 700;
                            letter-spacing: 0px;
                            line-height: 22px;
                            color: rgba(51, 51, 51, 1);
                        }
                    }
                }
            }
        }

        .el-checkbox {
            font-size: 16px;

            .el-checkbox__inner {
                width: 16px;
                height: 16px;
            }

            &.is-checked {
                .el-checkbox__inner {
                    &::after {
                        top: 2px;
                        left: 5px;
                    }
                }
            }

            .is-indeterminate {
                .el-checkbox__inner {
                    background-color: #ffffff;
                    border-color: #1990FF;

                    &::before {
                        width: 8px;
                        height: 8px;
                        opacity: 1;
                        border-radius: 1px;
                        background: #1990FF;
                        transform: scale(1);
                        left: 3px;
                        top: 3px;
                    }
                }
            }
        }

    }
}
</style>
